import { useSyncExternalStore } from 'react';

/**
 * The Attention queue's length, for the sidebar's Desk entry.
 *
 * The Desk page publishes it while it is mounted and clears it on unmount, so
 * the sidebar shows a count only while it is current. The queue cannot be
 * rebuilt in the sidebar: the live hooks keep per-instance state, and a second
 * subscriber to an already-held retained topic (gateway status) gets no
 * retained replay from the broker.
 */
let count: number | null = null;
const listeners = new Set<() => void>();

export function publishDeskAttentionCount(next: number | null): void {
  if (next === count) return;
  count = next;
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function useDeskAttentionCount(): number | null {
  return useSyncExternalStore(subscribe, () => count, () => null);
}
